import { useParams } from 'react-router-dom';
import AudioPlayer from './AudioPlayer';
import { cn } from '../../../lib/utils';
import { useThemeQuery } from '../../../reactQuery/get';
import { AudioMessageProps } from '../../../types';

function AudioMessage({ url, isUser, isSilent }: AudioMessageProps) {
  const { organization_id, project_id, chat_id } = useParams();
  const projectId = organization_id ? project_id : chat_id;
  const { data: themeData } = useThemeQuery(projectId);
  return (
    <div>
      <div
        style={{
          backgroundColor: isUser && !isSilent ? themeData?.['chat-primary'] : '#FFFFFF',
        }}
        className={cn(isUser ? 'text-white' : 'text-dark-text')}
      >
        <AudioPlayer url={url} isUserMessage={isUser} isSilent={isSilent} />
      </div>
    </div>
  );
}

export default AudioMessage;
